import { StackProps, Text, VStack } from '@elkaso-app/web-design';
import { PhoneNumber } from '../../../components/base-table';

export interface IPocAgentDetailsCell extends StackProps {
  agentProvider: string;
  agentId: string;
  phoneNumber: string;
}

export const PocAgentDetailsCell = ({ agentProvider, agentId, phoneNumber, ...rest }: IPocAgentDetailsCell) => {
  return (
    <VStack spacing='sm' align='start' {...rest}>
      <Text
        whiteSpace='pre-line'
        color={'red.500'}
        fontWeight='500'
        _hover={{ color: 'red.500' }}
        _focus={{ color: 'red.500' }}>
        {agentProvider.toUpperCase()}{' '}
        <Text as='span' fontSize='xs' color='gray.500'>
          [{agentId}]
        </Text>
      </Text>

      <PhoneNumber value={phoneNumber} showWhatsApp={false} />
    </VStack>
  );
};
